 enum auditSharingPermission {
    CertificatePDF = "Certification data + Certificate PDF accessible",
    CertificateOnly = "Certification data accessible only (PDF inaccessible)",
    BasicOnly="Basic display only (Certification data inaccessible, PDF inaccessible)"
  }
  export default auditSharingPermission;